<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Activity Timeout</p>
    </header>
    <section class="modal-card-body">
      <p>For your security, this session will expire in <strong class="has-text-danger">{{ sessionCountdown }}</strong> due to inactivity. If you want to extend your session, please select the 'Continue' button. If you select the 'Log Out' button or do not respond, your session will automatically close.</p>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="logout">Logout</button>
      <button class="button is-primary" @click="maintainSession">Continue</button>
    </footer>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { AUTH_LOGOUT, AUTH_SESSION_KEEPALIVE } from '../../store/actions/auth'

export default {
  data () {
    return {
      sessionCountdown: null,
      countdownInterval: null
    }
  },
  computed: {
    ...mapState({
      lastActivity: 'lastActivity'
    })
  },
  beforeDestroy () {
    clearInterval(this.countdownInterval)
  },
  created () {
    this.countdownInterval = setInterval(this.updateCountdown, 1000)
  },
  methods: {
    updateCountdown () {
      if (moment.isMoment(this.lastActivity)) {
        const endTime = this.lastActivity.clone().add(60, 'minutes')
        const diff = endTime.diff(moment(), 'seconds')
        const minutes = Math.floor(diff / 60)
        const seconds = diff - minutes * 60
        if (diff < 0) {
          clearInterval(this.countdownInterval)
          this.logout()
        }
        this.sessionCountdown = minutes.toString().padStart(2, '0') +
          ':' +
          seconds.toString().padStart(2, '0')
      }
    },
    logout () {
      this.$store.dispatch(AUTH_LOGOUT).finally(() => {
        this.$buefy.snackbar.open({
          message: 'Griptiller logged you out due to inactivity.',
          type: 'is-light',
          actionText: null,
          indefinite: true,
          queue: false
        })

        const loginPath = window.location.pathname

        let queryString = { r: loginPath }
        if (loginPath === '/maintenance' || loginPath === '/' || loginPath === '/login') {
          queryString = undefined
        }

        this.$router.push({ name: 'login', query: queryString })
      })
    },
    maintainSession () {
      this.$store.dispatch(AUTH_SESSION_KEEPALIVE)
    }
  }
}
</script>

<style>
.modal-card {
  max-width: 600px;
}

.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/SessionActivity.vue